import { Link } from "react-router-dom";
import { ILinkProps, TableColumn } from "../../../Component/Model/Table/Table";
import { Typography } from "@mui/material";
import { ClientScorecard } from "../../../Component/Model/Dto/Advisory/ClientScorecard";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { DateFormatter } from "../../../Component/Model/helpers";
import config from "../../../config";
import { useRecoilValue } from "recoil";
import { userRolesState } from "../../../State/user.Atom";
import { AdvancedSupplierModuleRole } from "../../../Component/Common/Constants/UserRoles";

interface ClientScorecardRows {
    scorecardId: string;
    name: ILinkProps;
    scorecardType: string;
    createdDate: string;
    isConsolidated: string;
    fromDate: string;
    toDate: string;
}

interface ClientScorecardTable {
    columns: Array<TableColumn>;
    rows: Array<ClientScorecardRows>;
}

export function ClientScorecardDataTableColumns(results: ClientScorecard[]): ClientScorecardTable {
    const userRoles = useRecoilValue(userRolesState);

    const handleLinkClick = (item: ClientScorecard) => {
        if (userRoles.includes(AdvancedSupplierModuleRole)){
            window.location.href = (`${config.publicUrl}/#scorecard/${item.scorecardId}/dashboard/procurementDashboard`);   
        }
        else {
            window.location.href = (`${config.publicUrl}/#scorecard/${item.scorecardId}/dashboard`);   
        }
    };

    const columns : Array<TableColumn> = [
        { Header: 'Name', accessor: 'name', id: "scorecardName", Cell: ({ value }: any) => <Typography variant="caption" fontWeight='regular' color="#007bff" component={Link} to={value.linkTo}>{value.itemName}</Typography> },
        { Header: 'Scorecard Type', accessor: 'scorecardType', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Created Date', accessor: 'createdDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Consolidated Scorecard', accessor: 'isConsolidated', id: "consolidated", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'From Date', accessor: 'fromDate', id: "startDate", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'To Date', accessor: 'toDate', id: "endDate", Cell: ({ value }: any) => <DefaultCell value={value} />},
    ];

    if (results.length > 0) {
        const rows = results.map((item: ClientScorecard) => ({
            scorecardId: item.scorecardId,
            name: {
                linkTo: `/bee/scorecardLicense`, itemName:
                    (
                        <div
                            style={{ cursor: "pointer" }}
                            onClick={() => handleLinkClick(item)}
                        >
                            {item.scorecardName}
                        </div>
                    )
            },
            scorecardType: item.scorecardType,
            createdDate: DateFormatter(item.createdDate.toString()),
            isConsolidated: item.isConsolidated ? 'Yes' : 'No',
            fromDate: DateFormatter(item.startDate.toString()),
            toDate: DateFormatter(item.endDate.toString()),
            registrationId: item.registrationId,
        }));

        
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }

    
    
    

}

